import axios from 'axios'
import { useToast } from 'vue-toastification';

let _pending = 0;
function _startLoad() {
  if (++_pending === 1 && window.Fire) window.Fire.emit('sc:loading', true);
}
function _endLoad() {
  if (Math.max(0, --_pending) === 0 && window.Fire) window.Fire.emit('sc:loading', false);
}

// Attach Bearer token from localStorage to every request
axios.interceptors.request.use(function (config) {
    _startLoad();
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, function (error) {
    _endLoad();
    return Promise.reject(error);
});

// Unwrap response body and show toast for mutation requests (POST/PUT/PATCH/DELETE)
axios.interceptors.response.use(function (response) {
    const method = response.config?.method?.toLowerCase();
    const body = response?.data;
    const skipToast = response.config?.skipToast;

    if (!skipToast && method !== 'get' && body?.message) {
        const toast = useToast();
        if (body.status === 200) {
            toast.success(body.message);
        } else {
            toast.error(body.message);
        }
    }

    _endLoad();
    return body ?? response;
}, function (error) {
    _endLoad();
    const toast = useToast();
    const message = error?.response?.data?.message || 'Something went wrong. Please try again.';
    toast.error(message);
    return Promise.reject(error);
});

export default axios;
